var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"min-height":"calc(100vh - 125px)"}},[_c('p',{staticClass:"text-center my-10",staticStyle:{"font-size":"24px","color":"#f57c00","font-weight":"600"}},[_vm._v(" Welcome to Genic Assets ")])])
}]

export { render, staticRenderFns }